import { reactive } from "vue";

export const projectsState = reactive({
  currentProjectId: undefined,
});
